import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Item from './Item'

const propTypes = {
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  onItemClick: PropTypes.func.isRequired,
}

class List extends Component {
  constructor(props) {
    super(props)

    this.onItemClick = this.onItemClick.bind(this)
    this.itemsFactory = this.itemsFactory.bind(this)
  }

  onItemClick(val) {
    const { onItemClick } = this.props

    // call parent onItemClick method
    if (typeof onItemClick === 'function') {
      onItemClick(val)
    }
  }

  // items elements render
  itemsFactory() {
    const { selectedItem, items } = this.props
    return items.map((item) => {
      const hasChilds = !!item.folder
      return (
        <Item
          isSelected={selectedItem === item.id}
          key={item.id}
          id={item.id}
          text={item.text}
          provider={item.provider}
          type={hasChilds ? 'parent' : 'child'}
          status={item.status}
          onItemClick={hasChilds ? function () {} : this.onItemClick}
        />
      )
    })
  }

  render() {
    return <ul className="wb-list nav-list">{this.itemsFactory()}</ul>
  }
}

List.propTypes = propTypes

const mapStateToProps = function (state) {
  const { navMenuSelected } = state.global

  return {
    navMenuSelected,
  }
}
export default connect(mapStateToProps)(List)
